export function printUser(user: any) {
  if (!user || !user.id) {
    return "";
  }

  return `${user.firstName} ${user.lastName} (${user.email})`;
}
